import ClockIcon from "@mui/icons-material/AccessTimeOutlined";
import { Stack, Typography } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import { convertISODate, formatDate } from "@entrilia/shared/utilities/dateUtils";
import type { MessageDeliveryRecipient } from "../../../../../../api/types/documentCollectionTypes";
import DocumentCollectionContext from "../../DocumentCollectionContext";

interface Props {
  recipient: MessageDeliveryRecipient;
}

const getRecipientStatusText = (recipient: MessageDeliveryRecipient, sentInvites: Record<string, Date>) => {
  if (recipient.isRegistered) {
    return recipient.lastActivity ? `Last activity ${convertISODate(recipient.lastActivity)}` : "Registered";
  }

  if (!recipient.isInvited) {
    return "Not yet registered";
  }

  if (recipient.referenceId) {
    const storedInviteDate = sentInvites[recipient.referenceId];
    if (storedInviteDate) {
      return `Not yet registered - Invited ${formatDate(storedInviteDate)}`;
    }
  }

  if (recipient.invitedAt) {
    return `Not yet registered - Invited ${convertISODate(recipient.invitedAt)}`;
  }

  return "Not yet registered - Invited";
};

const ContactDeliveryStatus = ({ recipient }: Props) => {
  const { sentInvites } = useDefinedContext(DocumentCollectionContext);

  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <ClockIcon />
      <Typography color="textSecondary">{getRecipientStatusText(recipient, sentInvites)}</Typography>
    </Stack>
  );
};

export default ContactDeliveryStatus;
